import Modal from "react-modal";
import React from "react";
import { useTheme } from "react-jss";
import useStyles from "./ModalDialog.style";
import Button from "./Button";

export interface OkResult {
    isSuccess: boolean;
    message?: string;
    onSuccess?(): void;
}

interface Props {
    isOpen: boolean;
    title: string;
    okActionText: string;
    cancelActionText: string;
    onOkAction?(): OkResult;
    onCancelAction?(): void;
    children: unknown;
    isDisableConfirm?: boolean;
}

export default function ModalDialog(props: Props) {
    const [width, setWidth] = React.useState(window.innerWidth);
    const {
        onOkAction,
        onCancelAction,
        cancelActionText,
        okActionText,
        children,
        isOpen,
        title,
        isDisableConfirm,
    } = props;

    React.useEffect(() => {
        const updateWindowDimensions = () => {
            const newWidth = window.innerWidth;
            setWidth(newWidth);
        };
        window.addEventListener("resize", updateWindowDimensions);
        return () => window.removeEventListener("resize", updateWindowDimensions)
    }, []);

    const theme: any = useTheme();
    const classes = useStyles({ theme });
    const calculatedMargin = width / 2 - 200;
    const modalStyles = {
        content: {
            maxHeight: "541px",
            maxWidth: "400px",
            marginLeft: calculatedMargin,
            padding: 0
        },
        overlay: {
            zIndex: 1000,
        },
    };

    const onSaveAction = () => {
        const validation = onOkAction();
        if (validation.isSuccess) {
            if (validation.onSuccess) {
                validation.onSuccess();
            }
            onCancelAction();
            return;
        }

        alert(validation.message);
    }

    return (
        <Modal isOpen={isOpen} style={modalStyles} ariaHideApp={false} shouldCloseOnOverlayClick>
            <div className={classes.modalContent}>
                <div className={classes.modalHeader}>
                    <div className={classes.modalTitle}>{title}</div>
                    <button type="button" className={classes.closeButton} onClick={onCancelAction}>X</button>
                </div>
                <div className={classes.modalBody}>{children}</div>
                <div className={classes.modalFooter}>
                    <Button
                        text={cancelActionText}
                        onClick={onCancelAction}
                        size="large"
                        buttonType="CANCEL"
                    />
                    <Button
                        text={okActionText}
                        onClick={onSaveAction}
                        size="large"
                        buttonType="SUBMIT"
                        disabled={isDisableConfirm}
                    />
                </div>
            </div>
        </Modal>
    );
}
